// extracted by mini-css-extract-plugin
export default {"spinner":"SpinnerIndicator_spinner__QEoIu","loading":"SpinnerIndicator_loading__js6n+","spinnerIcon":"SpinnerIndicator_spinnerIcon__vFi5-"};